// store/checkoutStore.ts

//import { loadLocaCartHashlState, saveLocalCartHashState } from '../localstorage/localStorage';

import { configureStore, combineReducers } from '@reduxjs/toolkit';
import Cookies from 'js-cookie';

import { loadSessionState, saveSessionState } from '../localstorage/sessionStorage';
import { saveLocalCartHashState } from '../localstorage/localStorage';

import shoppingcartReducer from '../reducers/cartreducers/shoppingcartReducer';
import sidecartsettingsReducer from '../reducers/cartreducers/sidecartsettingsReducer';
import checkoutsettingsReducer from '../reducers/checkoutreducers/checkoutsettingsReducer';
import generalsettingsReducer from '../reducers/generalreducers/generalsettingsReducer';
import checkoutcontextallReducer from '../reducers/checkoutreducers/checkoutcontextallReducer';
import addresscurrentReducer from '../reducers/checkoutreducers/addresscurrentReducer';
import selectedorderdataReducer from '../reducers/checkoutreducers/selectedorderdataReducer';

const rootReducer = combineReducers({
  shoppingcart: shoppingcartReducer,
  sidecartsettings: sidecartsettingsReducer,
  checkoutcontext: checkoutcontextallReducer,
  generalsettings: generalsettingsReducer,
  checkoutsettings: checkoutsettingsReducer,
  addressdatacurrent: addresscurrentReducer,
  selectedorderdata: selectedorderdataReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

const initialState: Partial<RootState> = loadSessionState() || {};

const refreshCartFragments = async (store) => {
  const cart_hash_key = window.wc_cart_fragments_params?.cart_hash_key;

  if (!cart_hash_key) {
    console.warn('Cart hash key is undefined.');
    return;
  }

  const sessionCartHash = sessionStorage.getItem(cart_hash_key) || '';
  const localCartHash = localStorage.getItem(cart_hash_key) || '';
  const cookieCartHash = Cookies.get(cart_hash_key);

  if (sessionCartHash !== localCartHash || sessionCartHash !== cookieCartHash) {
    const base_url = store.getState().sidecartsettings.appSettings?.base_url;
    if (base_url) {
      const updateSideCart = new (await import('../update/UpdateSideCart.tsx')).default();
      await updateSideCart.refreshCartFragments(base_url);
    }
  }
};

const setupEventListeners = (store) => {
  const onVisibilityChange = () => refreshCartFragments(store);
  window.addEventListener('load', onVisibilityChange);
  document.addEventListener('visibilitychange', onVisibilityChange);

  return () => {
    window.removeEventListener('load', onVisibilityChange);
    document.removeEventListener('visibilitychange', onVisibilityChange);
  };
};

const store = configureStore({
  reducer: rootReducer,
  preloadedState: initialState,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

store.subscribe(() => {
  const currentState = store.getState();
  saveSessionState(currentState);

  const cartHash = currentState.shoppingcart?.metacartdata?.[0]?.carthash;
  if (cartHash) {
    saveLocalCartHashState(cartHash);
    const cart_hash_key = window.wc_cart_fragments_params?.cart_hash_key;
    Cookies.set(cart_hash_key, cartHash);
  }
});

setupEventListeners(store);

export type AppStore = typeof store; // Korrekt: Typ des tatsächlichen Stores
export type AppDispatch = AppStore['dispatch'];
export default store;